import { render, staticRenderFns } from "./VideoFriendPicker.vue?vue&type=template&id=2bab271c&scoped=true"
import script from "./VideoFriendPicker.vue?vue&type=script&lang=js"
export * from "./VideoFriendPicker.vue?vue&type=script&lang=js"
import style0 from "./VideoFriendPicker.vue?vue&type=style&index=0&id=2bab271c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bab271c",
  null
  
)

export default component.exports